<template>
    <div class="content_box mobile_content">
        <div class="content home">
            <div class="welcome">
                <span>{{`Hi~${$store.state.userInfo.name || ''}，欢迎来到集海运营平台`}}</span>
            </div>
            <div class="quick_enter">
                <div class="quick_enter_item" v-for="item in quickData" :key="item.path" @click="routerGo(item)">
                    <img :src="item.ico" alt="">
                    <p>{{item.name}}</p>
                </div>
            </div>
        </div>
    </div>  
    
</template>
<script>
export default({
    name: 'home',
    data() {
        return {
            username: '',
            quickData: [
                {
                    key: 'work-order',
                    name: '工单管理',
                    path: 'order-manage',
                    permission: '101-102-101-101',
                    ico: require('../assets/images/home/order.png')
                },{
                    key: 'work-order',
                    name: '工单数据总览',
                    path: 'overview',
                    m_path: 'overview-mobile',
                    permission: '101-101-101-101',
                    ico: require('../assets/images/home/knowledge.png')
                },{
                    key: 'statistics',
                    name: '销售运营报表',
                    path: 'sales-overview',
                    permission: '102-100-101-101',
                    ico: require('../assets/images/home/app-operation.png')
                },{
                    key: 'statistics',
                    name: '设备运营报表',
                    path: 'device-operation',
                    permission: '102-102-101-101',
                    ico: require('../assets/images/home/device-operation.png')
                }
            ]
        }
    },
    created() {
        
    },
    mounted() {
       
    },
    methods: {
        routerGo(item) {
            if(this.$store.state.userInfo.permission.indexOf(item.permission) != -1 || this.$store.state.userInfo.role.indexOf('系统管理员') != -1){
                const path = this.$store.state.type == 'pc' ? item.path : (item.m_path || item.path);
                this.$router.push({name: path});
            }else{
                this.$message.warning('用户暂无访问权限！');
            }
        }
    },
    beforeDestroy() {
        
    }
})
</script>
<style lang="less" scoped>
    .welcome{
        font-size: 28px;
        font-weight: 600;
        text-align: center;
        margin: 10vh 0 20vh;
    }
    .quick_enter{
        .flexLayout(space-evenly);
        .quick_enter_item{
            width: 200px;
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            cursor: pointer;
            margin-bottom: 40px;
            img{
                .contentWdith(160px);
                margin-bottom: 20px;
            }
        }
    }
    @media (max-width: 768px) {
        .welcome{
            font-size: 18px;
            margin: 60px 0;
        }
        .quick_enter{
            .flexLayout(space-evenly);
            .quick_enter_item{
                width: 150px;
                font-size: 16px;
                img{
                    width: 100px;
                    margin-bottom: 0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/home.vue